import instance from '@/api/business'
import { CreatedOperationProps, UpdateOperationProps, DeleteOperationProps, CreatedSegmentOperationProps, UpdateSegmentOperationProps } from './type'
import { Operation, SegmentOperation } from '@/types/Operation' 

const BASE_URL = '/operation/cockpit/operation'

export const fetchOperation = async () => {
    const response = await instance.post<Operation[]>(BASE_URL)

    return response.data
}
 
export const createOperation = async (data: CreatedOperationProps) => {
    const response = await instance.put(BASE_URL, data)

    return response.data

}

export const updateOperation = async (data: UpdateOperationProps) => {
    const response = await instance.patch(BASE_URL, data)

    return response.data
}

export const deleteOperation = async (props: DeleteOperationProps) => {
    const response = await instance.delete(BASE_URL, {
        data: props,
    })

    return response.data
}


export const fetchSegmentOperation = async ( id : Number) => {
    const response = await instance.post<SegmentOperation[]>(`${BASE_URL}/segment`,{
        SK_OPERACAO: id
    })

    return response.data
}
 
export const createSegmentOperation = async (data: CreatedSegmentOperationProps) => {
    const response = await instance.put(`${BASE_URL}/segment`, data)

    return response.data 
} 

export const updateSegmentOperation = async (data: UpdateSegmentOperationProps) => {
    const response = await instance.patch(`${BASE_URL}/segment`, data)

    return response.data
}